export default __webpack_public_path__ + "static/media/gallery-wip-handle_01.06970c1b.jpg";